import {
  CellContext,
  ColumnDefTemplate,
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import classNames from 'classnames';
import { differenceInYears } from 'date-fns';
import { TanstackTable } from '../../Table/TanstackTable';
import { CompoundHistory, formatNumber } from '../CompoundPage.hooks';
import styles from './CompoundTable.module.css';

interface CompoundTableProps {
  histories: CompoundHistory[];
  className?: string;
}

const columnHelper = createColumnHelper<CompoundHistory>();

const formatCurrency: ColumnDefTemplate<CellContext<CompoundHistory, number>> = (value) =>
  formatNumber(value.getValue());

const columns = [
  columnHelper.accessor('time', {
    cell: (info) => {
      const startTime = info.table.options.data[0].time;
      const yearDuration = differenceInYears(info.getValue(), startTime);
      return `${yearDuration}년차`;
    },
    header: '년차',
  }),
  columnHelper.accessor('principalAmount', {
    header: '원금',
    cell: formatCurrency,
  }),
  columnHelper.accessor('totalInterest', {
    header: '누적 수익',
    cell: formatCurrency,
  }),
  columnHelper.accessor('amount', {
    header: '총액',
    cell: formatCurrency,
  }),
];

function CompoundTable({ histories, className }: CompoundTableProps) {
  const table = useReactTable({
    data: histories,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return <TanstackTable className={classNames(styles.root, className)} table={table} />;
}

export default CompoundTable;
